import request from '@/utils/request'


// 登录
export function login(params) {
    return request({
        url: '/api/login',
        method: 'post',
        data: params
    })
}

// 退出
export function logout() {
    return request({
        url: '/api/auth/logout',
        method: 'post',
        isAuth: true,
    })
}

// 获取用户信息
export function getInfo(params) {
    return request({
        url: '/api/userinfo',
        method: 'get',
        params,
        isAuth: true,
    })
}


// 注册
export function register(params) {
    return request({
        url: '/api/register',
        method: 'post',
        data: params
    })
}
//获取手机验证码
export function validCode(phone){
    return request({
        url: '/api/register/' + phone,
        method: 'post'
    })
}

// 修改密码
export function registerPwd(params) {
    return request({
        url: '/api/register/reset',
        method: 'post',
        data: params,
        isAuth: true,

    })
}

// 获取用户照片列表
export function getUserPhotos(params) {
    return request({
        url: '/api/user/photos',
        method: 'get',
        params,
        isAuth: true,
    })
}

// 上传用户照片
export function uploadUserPhoto(params) {
    return request({
        url: '/api/user/photo/upload',
        method: 'post',
        data: params,
        headers: {
            "Content-Type": "multipart/form-data",
        },
        isAuth: true,
    })
}

// 删除用户照片
export function deleteUserPhoto(params) {
    return request({
        url: '/api/user/photo/delete',
        method: 'post',
        params,
        isAuth: true,
    })
}